import { z } from "zod";

export const LabelDataFormat = {
	RawZpl: "RawZpl",
	StandardBase64EncodedZpl: "StandardBase64EncodedZpl",
	UrlSafeBase64EncodedZpl: "UrlSafeBase64EncodedZpl",
};

export const labelDataFormatSchema = z.enum([
	LabelDataFormat.RawZpl,
	LabelDataFormat.StandardBase64EncodedZpl,
	LabelDataFormat.UrlSafeBase64EncodedZpl,
] as const);

export type LabelDataFormatType = z.infer<typeof labelDataFormatSchema>;
